const DEFAULT_TEAM_LOGO_SVG = encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
    <rect width="120" height="120" rx="24" fill="#111827"/>
    <circle cx="60" cy="46" r="18" fill="#D1FAE5"/>
    <path d="M30 93c0-14 13-24 30-24s30 10 30 24v3H30v-3z" fill="#A7F3D0"/>
    <text x="60" y="112" text-anchor="middle" fill="#F8FAFC" font-family="Arial, sans-serif" font-size="10" font-weight="700">AH SHOOT</text>
  </svg>`,
);
const DEFAULT_TEAM_LOGO_URL = `data:image/svg+xml;utf8,${DEFAULT_TEAM_LOGO_SVG}`;

function ClientTeamSelectPage({
  teams,
  currentUser,
  onSelectTeam,
}) {
  return (
    <main
      className="min-h-screen px-6 py-8 md:px-10 md:py-10"
      style={{
        background:
          "radial-gradient(circle at 8% 0%, #dcfce7 0, transparent 30%), radial-gradient(circle at 100% 10%, #dbeafe 0, transparent 34%), linear-gradient(160deg, #f8fafc 0%, #eef2ff 100%)",
      }}
    >
      <div className="mx-auto flex w-full max-w-[980px] flex-col gap-6">
        <header className="rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 shadow-[0_16px_40px_rgba(15,23,42,0.08)] backdrop-blur-sm">
          <p className="m-0 inline-block rounded-full bg-[#111827] px-3 py-1 text-xs font-bold tracking-[0.08em] text-white">
            TEAM SELECT
          </p>
          <h1 className="mt-3 text-[clamp(24px,4.5vw,34px)] font-semibold leading-tight tracking-[-0.03em] text-[#0f172a]">
            팀 워크스페이스 선택
          </h1>
          <p className="mt-2 text-sm text-[#475467]">
            {currentUser?.nickname || currentUser?.email || "사용자"}님이 가입한
            팀입니다.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => window.location.replace("/teams/new")}
              className="h-10 rounded-lg bg-[#111827] px-4 text-sm font-semibold text-white"
            >
              팀 등록
            </button>
            <button
              type="button"
              onClick={() => window.location.replace("/teams/find")}
              className="h-10 rounded-lg border border-[#d0d5dd] bg-white px-4 text-sm font-semibold text-[#344054]"
            >
              팀 찾기
            </button>
          </div>
        </header>

        <section className="rounded-3xl border border-[#dbe4f4] bg-white/90 p-6 shadow-[0_12px_30px_rgba(15,23,42,0.06)]">
          {teams.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-[#d0d5dd] bg-[#f8fafc] p-6">
              <p className="m-0 text-base font-semibold text-[#101828]">
                가입된 팀이 없습니다.
              </p>
              <p className="mt-2 text-sm text-[#667085]">
                팀을 새로 만들거나, 팀 가입 승인을 받은 뒤 다시 접속해 주세요.
              </p>
            </div>
          ) : (
            <div className="grid gap-3 md:grid-cols-2">
              {teams.map((team) => (
                <button
                  key={team.id}
                  type="button"
                  onClick={() => onSelectTeam(team.id)}
                  className="rounded-2xl border border-[#dbe4f4] bg-white p-4 text-left transition hover:border-[#98a2b3] hover:bg-[#f8fafc]"
                >
                  <div className="flex items-start gap-4">
                    <div className="h-14 w-14 overflow-hidden rounded-2xl border border-[#d0d5dd] bg-white shadow-sm">
                      <img
                        src={team.logoUrl || DEFAULT_TEAM_LOGO_URL}
                        alt={`${team.name} 로고`}
                        onError={(event) => {
                          event.currentTarget.src = DEFAULT_TEAM_LOGO_URL;
                        }}
                        className="h-full w-full object-cover"
                      />
                    </div>

                    <div className="min-w-0 flex-1">
                      <p className="m-0 text-xs font-semibold tracking-wide text-[#475467]">
                        {team.role}
                      </p>
                      <p className="mt-1 text-base font-semibold text-[#101828]">
                        {team.name}
                      </p>
                      <p className="mt-1 text-sm text-[#475467]">
                        회장 {team.chair} | {team.timeRange}
                      </p>
                      <p className="mt-1 text-xs text-[#667085]">
                        활동 요일: {team.activityWeekdays.join(", ")}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}

        </section>
      </div>
    </main>
  );
}

export default ClientTeamSelectPage;
